// lcdcash-frontend/src/components/tarifs/Intro.jsx
import * as React from 'react';
import { Box, Typography, Paper } from '@mui/material';

// i18n
import { useI18n } from '../../i18n/I18nProvider';
import introI18n from '../../i18n/components/tarifs/intro.i18n';

const GREEN = '#0466c8';

function StepCard({ n, title, children }) {
  return (
    <Paper
      elevation={0}
      sx={{
        position: 'relative',
        bgcolor: GREEN,
        color: '#fff',
        borderRadius: 3,
        p: { xs: 2, md: 2.5 },
        pt: { xs: 3.5, md: 4 },
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
      }}
    >
      {/* Médaillon numéroté */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          transform: 'translate(25%, -55%)',
          height: 44,
          width: 44,
          borderRadius: '50%',
          bgcolor: '#fff',
          border: '2px solid #e5efe6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 900,
          color: GREEN,
          fontSize: 18,
          boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
        }}
      >
        {n}
      </Box>

      <Typography
        sx={{
          fontWeight: 800,
          mb: 1,
          fontSize: { xs: 16, md: 18 },
          lineHeight: 1.3,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          opacity: 0.95,
          lineHeight: 1.45,
          fontSize: { xs: 13.5, md: 15 },
        }}
      >
        {children}
      </Typography>
    </Paper>
  );
}

export default function TarifsIntro() {
  const { t, register } = useI18n();
  React.useEffect(() => { register('tarifs', introI18n); }, [register]);

  return (
    <Box sx={{ mt: { xs: 2, md: 3 }, mb: { xs: 2, md: 3 } }}>
      {/* Texte d’introduction */}
      <Box sx={{ mb: { xs: 3, md: 4 } }}>
        <Typography sx={{ fontSize: { xs: 14.5, md: 18 }, lineHeight: 1.6 }}>
          {t('tarifs.intro.lead.l1.s1')}
          <b>{t('tarifs.intro.lead.l1.b1')}</b>
          {t('tarifs.intro.lead.l1.s2')}
          <b>{t('tarifs.intro.lead.l1.b2')}</b>
          {t('tarifs.intro.lead.l1.s3')}
          <b>{t('tarifs.intro.lead.l1.b3')}</b>
          {t('tarifs.intro.lead.l1.s4')}<br />
          {t('tarifs.intro.lead.l2.s1')}
          <b>{t('tarifs.intro.lead.l2.b1')}</b>
          {t('tarifs.intro.lead.l2.s2')}
          <b>{t('tarifs.intro.lead.l2.b2')}</b>
          {t('tarifs.intro.lead.l2.s3')}
          <b>{t('tarifs.intro.lead.l2.b3')}</b>
          {t('tarifs.intro.lead.l2.s4')}<br />
          {t('tarifs.intro.lead.l3.s1')}
          <b>{t('tarifs.intro.lead.l3.b1')}</b>
          {t('tarifs.intro.lead.l3.s2')}
          <b>{t('tarifs.intro.lead.l3.b2')}</b>
          {t('tarifs.intro.lead.l3.s3')}
          <b>{t('tarifs.intro.lead.l3.b3')}</b>
          {t('tarifs.intro.lead.l3.s4')}
          <b>{t('tarifs.intro.lead.l3.b4')}</b>
          {t('tarifs.intro.lead.l3.s5')}
          <b>{t('tarifs.intro.lead.l3.b5')}</b>
          {t('tarifs.intro.lead.l3.s6')}
        </Typography>
      </Box>

      {/* Cartes étapes */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: { xs: 2, md: 3 },
          mb: { xs: 3, md: 4 },
        }}
      >
        <StepCard n={1} title={t('tarifs.intro.cards.c1.title')}>
          {t('tarifs.intro.cards.c1.body')}
        </StepCard>
        <StepCard n={2} title={t('tarifs.intro.cards.c2.title')}>
          {t('tarifs.intro.cards.c2.body')}
        </StepCard>
        <StepCard n={3} title={t('tarifs.intro.cards.c3.title')}>
          {t('tarifs.intro.cards.c3.body')}
        </StepCard>
      </Box>

      {/* Paragraphe final sur une seule ligne */}
      <Typography sx={{ fontSize: { xs: 14.5, md: 18 }, lineHeight: 1.6 }}>
        <b>{t('tarifs.intro.outro.b1')}</b>
        {t('tarifs.intro.outro.s1')}
        <b>{t('tarifs.intro.outro.b2')}</b>
        {t('tarifs.intro.outro.s2')}
      </Typography>
    </Box>
  );
}